import { useQuery } from "react-query";
import Select from "react-select";

import { getcityBycountryId } from "../../../../../MyApi/sb/cites";
import { getCountries } from "../../../../../MyApi/sb/countries";
import { getCompanies } from "../../../../../MyApi/hr/companies";
import { getBranches } from "../../../../../MyApi/sb/branches";
import { getDepartments } from "../../../../../MyApi/sb/departments";
import { getNationalities } from "../../../../../MyApi/sb/natonalities";
import { getShifts } from "../../../../../MyApi/sb/shifts";

import BankInfoCard from "../bankinfocard";
import icons from "../../../../../Data/icons";

import classes from "./addEmploy.module.css";

const AddEmploy = ({
  name_ar,
  name_en,
  nation_id,
  role,
  address,
  birthdate,
  access_system,
  email,
  mobile,
  setCityId,
  setCountryId,
  setNameAr,
  setNameEn,
  setMobile,
  setNationId,
  setBranchId,
  setEmail,
  setSbDepartmentId,
  setSbNationalityId,
  setBirthDate,
  setAcessSystem,
  setRole,
  active,
  setActive,
  setCompanyId,
  setAdress,
  countryId,
  password,
  setPassword,
  branchId,
  companyId,
  setInsuranceNumber,
  setTaxNumber,
  setBankName,
  setBankSwiftCode,
  setBankAccountNumber,
  setPayrollMethod,
  tax_number,
  payroll_method,
  bank_account_number,
  bank_swiftcode,
  bank_name,
  insurance_number,
  setImage,
  setShiftId,
  check_In_outside,setCheckInOutside
}) => {
  const page = 0;
  const cityQuery = useQuery(
    ["getcityById", countryId],
    () => getcityBycountryId(countryId),
    {
      enabled: !!countryId,
    }
  );
  const countryQuery = useQuery("getCountries", getCountries);
  const companyQuery = useQuery(["getcompanies", page], () =>
    getCompanies(page)
  );

  const branchesQuery = useQuery(
    ["getBranches", companyId],
    () => getBranches(page, companyId),
    {
      enabled: !!companyId,
    }
  );
  const DepartmentsQuery = useQuery(
    ["getDepartments",  branchId],
    () => getDepartments(page, branchId),
    {
      enabled: !!branchId,
    }
  );

  const nationalityQuery = useQuery("getnationality", getNationalities);
  const shiftsQuery =useQuery("getshifts" ,getShifts)

  const branches = branchesQuery.data?.data || [];
  const departments = DepartmentsQuery.data?.data || [];
  const nationalities = nationalityQuery.data?.data || [];
  const cites = cityQuery.data?.data || [];
  const countries = countryQuery.data?.data || [];
  const companies = companyQuery.data?.data || [];
  const shifts = shiftsQuery.data?.data ||[]
 

  const DollarSign = icons.Dollar;
  const Company = icons.company;
  const Country = icons.Earth;
  const City = icons.City;
  const RoleIcon = icons.employ;
  const NationalityIcon = icons.PassPort;
  const Phone = icons.phone;
  const Address = icons.address;
  const ABCIcon = icons.abc;
  const DateIcon = icons.date;

  console.log(role,"roleselected")
const user = JSON.parse(localStorage.getItem("user"))
const roleEmploye =user.role 
let roles = [

    "administrator",
    "branch_administrator",
    "department_administrator",
    "employe",
  ];
if(roleEmploye==="system_adminstrator"){
  roles=[
    "system_adminstrator",
    "administrator",
    "branch_administrator",
    "department_administrator",
    "employe",
  ]
}
 


  const handleNameArChange = (e) => {
    setNameAr(e.target.value);
  };
  const handleNameEnChange = (e) => {
    setNameEn(e.target.value);
  };
  const handleBirthDateChange = (e) => {
    setBirthDate(e.target.value);
  };
  const handleMobileChange = (e) => {
    setMobile(e.target.value);
  };
  const handleAddressChange = (e) => {
    setAdress(e.target.value);
  };
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handleAccessSystemChange = (e) => {
    const isChecked = e.target.checked;
    setAcessSystem(isChecked ? 1 : 0);
  };

  const handleNationIdChange = (e) => {
    setNationId(e.target.value);
  };
  const handleRoleChange = (e) => {
    setRole(e.target.value);
  };
  const handleNationalityIdChange = (e) => {
    setSbNationalityId(e.target.options[e.target.selectedIndex].id);
  };
  const handleBranchIdChange = (selectedBranch) => {
    const branchId = selectedBranch ? selectedBranch.id : null;
    setBranchId(branchId);
  };
  const handleCityIdChange = (e) => {
    setCityId(e.target.options[e.target.selectedIndex].id);
  };
  const handleCountryIdChange = (e) => {
    setCountryId(e.target.options[e.target.selectedIndex].id);
  };
  const handleCompanyIdChange = (selectedCompany) => {
    const companyId = selectedCompany ? selectedCompany.id : 0;
    setCompanyId(companyId);
  };
  const handleDepartmentChange = (selectedDepartment) => {
    const departmentId = selectedDepartment ? selectedDepartment.id : 0;
    setSbDepartmentId(departmentId);
  };

  const handlePasswordChange = (e) => {
    const { value } = e.target;
    setPassword(value);
  };

  const handleActiveChange = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setActive(1);
    } else {
      setActive(0);
    }
  };
  const handleShiftIdChange=(selectedOption)=>{
    const shiftId = selectedOption ? selectedOption.id :0
    setShiftId(shiftId)
  }
  const handelImageChange =(e)=>{
    const file = e.target.files[0]
    setImage(file)  
  }
  const handleOutSideCheckInChange =(e)=>{
    const isChecked =e.target.checked
    const newState=isChecked?1:0
    setCheckInOutside(newState)
  }

  return (
    <div className="row mb-3">
      <div className="col-lg-6">
        <div className="card mb-2">
          <div className="card-body">
            <div className={classes.formGrid}>
              <div className={classes.formCol}>
                <label htmlFor="">الاسم باللغة العربية</label>
                <div className={classes.iconInput}>
                  <ABCIcon />
                </div>
                <input
                  type="text"
                  value={name_ar}
                  placeholder="  ادخل الاسم باللغة العربية"
                  onChange={handleNameArChange}
                  className={classes.inputCustom}
                />
              </div>
              <div className={classes.formCol}>
                <label htmlFor="">الاسم باللغة الانجليزية</label>
                <div className={classes.iconInput}>
                  <ABCIcon />
                </div>
                <input
                  type="text"
                  value={name_en}
                  placeholder="  ادخل الاسم باللغة الانجليزية"
                  onChange={handleNameEnChange}
                  className={classes.inputCustom}
                />
              </div>
              <div className={classes.formCol}>
                <label htmlFor="">تاريخ الميلاد </label>
                <div className={classes.iconInput}>
                  <DateIcon />
                </div>
                <input
                  type="date"
                  value={birthdate}
                  placeholder="  ادخل   تاريخ الميلاد"
                  onChange={handleBirthDateChange}
                  className={classes.inputCustom}
                />
              </div>
              <div className={classes.formCol}>
                <label htmlFor=""> رقم الهاتف </label>
                <div className={classes.iconInput}>
                  <Phone />
                </div>
                <input
                  type="text"
                  placeholder=" رقم الهاتف "
                  value={mobile}
                  onChange={handleMobileChange}
                  className={classes.inputCustom}
                />
              </div>
              <div className={classes.formCol}>
                <label htmlFor="">الصورة</label>
                <input type="file"  accept="png,jpg,svg,jpeg,webp,gif" onChange={handelImageChange}   className={classes.inputCustom} />

              </div>

              <div className={classes.formCol}>
                <label htmlFor=""> رقم الهوية الوطنية </label>
                <div className={classes.iconInput}>
                  <Address />
                </div>
                <input
                  type="number"
                  placeholder="رقم الهوية الوطنية "
                  value={nation_id}
                  onChange={handleNationIdChange}
                  className={classes.inputCustom}
                />
              </div>

              <div className={classes.formCol}>
                <label htmlFor=""> العنوان</label>
                <div className={classes.iconInput}>
                  <Address />
                </div>
                <input
                  type="text"
                  placeholder="ادخل العنوان "
                  value={address}
                  onChange={handleAddressChange}
                  className={classes.inputCustom}
                />
              </div>

              <div className={classes.formCol}>
                <label htmlFor=""> الايميل</label>
                <div className={classes.iconInput}>
                  <Address />
                </div>
                <input
                  type="email"
                  placeholder="ادخل الايميل "
                  value={email}
                  onChange={handleEmailChange}
                  className={classes.inputCustom}
                />
              </div>
              <div className={classes.formCol}>
                <label htmlFor=""> كلمة المرور </label>
                <div className={classes.iconInput}>
                  <Address />
                </div>
                <input
                  type="password"
                  placeholder="  ادخل كلمه المرور "
                  value={password}
                  onChange={handlePasswordChange}
                  className={classes.inputCustom}
                />
              </div>
            </div>
          </div>
        </div>
        <BankInfoCard
          insurance_number={insurance_number}
          tax_number={tax_number}
          payroll_method={payroll_method}
          bank_account_number={bank_account_number}
          bank_swiftcode={bank_swiftcode}
          bank_name={bank_name}
          classes={classes}
          setBankName={setBankName}
          setPayrollMethod={setPayrollMethod}
          setInsuranceNumber={setInsuranceNumber}
          setBankAccountNumber={setBankAccountNumber}
          setTaxNumber={setTaxNumber}
          setBankSwiftCode={setBankSwiftCode}
        />
      </div>
      <div className="col-lg-6">
        <div className="card">
          <div className="card-body">
            <div className={classes.formGrid}>
              <div className={classes.formCol}>
                <label htmlFor="company"> اختار الشركة</label>

                {!companyQuery.data ? (
                  <div> no data available</div>
                ) : (
                  <Select
                    isClearable={true}
                    type="text"
                    placeholder="اختار الشركة"
                    getOptionValue={(e) => e.id}
                    getOptionLabel={(e) => e.name}
                    options={companies}
                    onChange={handleCompanyIdChange}
                  />
                )}
              </div>

              <div className={classes.formCol}>
                <label htmlFor="branch"> اختار الفرع</label>
                {!branchesQuery.data ? (
                  <div>يجب اختيار شركة </div>
                ) : (
                  <Select
                    type="text"
                    placeholder="اختار الفرع"
                    options={branches}
                    getOptionValue={(e) => e.id}
                    isClearable={true}
                    getOptionLabel={(e) => e.name}
                    onChange={handleBranchIdChange}
                  />
                )}
              </div>


              <div className={classes.formCol}>
                <label htmlFor="department"> اختار القسم</label>
                {!DepartmentsQuery.data ? (
                  <div>يجب اختيار فرع</div>
                ) : (
                  <Select
                    type="text"
                    isClearable={true}
                    placeholder="اختار القسم"
                    getOptionValue={(e) => e.id}
                    getOptionLabel={(e) => e.name}
                    options={departments}
                    onChange={handleDepartmentChange}
                  />
                )}
              </div>

             
              <div className={classes.formCol}>
                <label htmlFor="company"> اختار الدولة</label>
                <div className={classes.iconInput}>
                  <Country />
                </div>

                <select
                  type="text"
                  onChange={handleCountryIdChange}
                  className={classes.inputCustom}>
                  {!countryQuery.data ? (
                    <div>no data available </div>
                  ) : (
                    <>
                      <option value="">اختار الدولة</option>
                      {countries.map((country) => (
                        <option
                          key={country.id}
                          id={country.id}
                          value={country.name}>
                          {country.name}
                        </option>
                      ))}
                    </>
                  )}
                </select>
              </div>

              <div className={classes.formCol}>
                <label htmlFor="city"> اختار المدينة</label>
                <div className={classes.iconInput}>
                  <City />
                </div>

                <select
                  type="text"
                  onChange={handleCityIdChange}
                  // disabled={isCityDisabled()}
                  className={classes.inputCustom}>
                  {!cityQuery.data ? (
                    <div>no data avalible</div>
                  ) : (
                    <>
                      <option value="">
                        {" "}
                        {cites.length === 0 ? "لايوجد مدن " : "اختار المدينة"}
                      </option>

                      {cites.map((city) => (
                        <option key={city.id} id={city.id} value={city.name}>
                          {" "}
                          {city.name}
                        </option>
                      ))}
                    </>
                  )}
                </select>
              </div>

        
              <div className={classes.formCol}>
                <label htmlFor="shifts"> اختار نوبات العمل</label>
                {!shiftsQuery.data ? (
                  <div>no data avalible   </div>
                ) : (
                  <Select
                    type="text"
                    isClearable={true}
                    placeholder="اختار نوبات العمل"
                    options={shifts}
                    getOptionValue={(e) => e.id}
                    getOptionLabel={(e) => e.name}
                    onChange={handleShiftIdChange}
                  />
                )}
              </div>

           

              <div className={classes.formCol}>
                <label htmlFor="department"> اختار الجنسية</label>
                <div className={classes.iconInput}>
                  <NationalityIcon />
                </div>
                {!nationalityQuery.data ? (
                  <div>no data available </div>
                ) : (
                  <select
                    type="text"
                    onChange={handleNationalityIdChange}
                    className={classes.inputCustom}>
                    <option value="">اختار الجنسية</option>
                    {nationalities.map((nationlity) => (
                      <option
                        key={nationlity.id}
                        id={nationlity.id}
                        value={nationlity.name}>
                        {nationlity.name}
                      </option>
                    ))}
                  </select>
                )}
              </div>
         
            

              <div className={classes.formCol}>
                <label htmlFor="role">اختار الدور</label>
                <div className={classes.iconInput}>
               <RoleIcon/>
                </div>
                <select
                  className={classes.inputCustom}
                  onChange={handleRoleChange}>
                  <option value=" ">اختار الدور</option>
                  {roles.map((role, i) => (
                    <option key={i} value={role}>
                      {role}
                    </option>
                  ))}
                </select>
              </div>

              <div className={classes.formCol}>
                <label
                  htmlFor="active"
                  className={
                    active ? `${classes.active}` : `${classes.disActive}`
                  }>
                  {" "}
                  {active === 1 ? " نشط" : "غير نشط"}{" "}
                </label>

                <label class="switch">
                  <input
                    type="checkbox"
                    onChange={handleActiveChange}
                    checked={active}
                  />
                  <span class="slider round"></span>
                </label>
              </div>

              <div className={classes.formCol}>
                <label
                  htmlFor="accesssystem"
                  className={
                    access_system ? `${classes.active}` : `${classes.disActive}`
                  }>
                  {" "}
                  {access_system === 1
                    ? " إمكانية الوصول للنظام"
                    : "لا بمكن الوصول للنظام "}{" "}
                </label>

                <label class="switch">
                  <input
                    type="checkbox"
                    onChange={handleAccessSystemChange}
                    checked={access_system}
                  />
                  <span class="slider round"></span>
                </label>
              </div>
              <div className={classes.formCol}>
                <label
                  htmlFor="accesssystem"
                  className={
                    check_In_outside ? `${classes.active}` : `${classes.disActive}`
                  }>
              
                  {check_In_outside === 1
                    ? " تسجيل الحضور و الانصراف  من خارج الفرع "
                    : " لا تسجيل للحضور و الانصراف  من خارج الفرع  "}
                </label>

                <label class="switch">
                  <input
                    type="checkbox"
                    onChange={handleOutSideCheckInChange}
                    checked={check_In_outside}
                  />
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEmploy;
